import { FormNeed4SteelOffer } from './form-mill-offer';
import { Need4SteelOffer } from './need4steel';

export enum Need4SteelWizardStep {
	HEADER = 0, SUMMARY = 1, CONFIRMATION = 2
}

class WizardStateMillOffer {
	static COMPUTE_INDEX_STEP(offer: Need4SteelOffer | FormNeed4SteelOffer) {
		const form = offer instanceof FormNeed4SteelOffer ? offer : new FormNeed4SteelOffer().setMillOffer(offer);
		if (!form.isOfferHeaderValid()) {
			return Need4SteelWizardStep.HEADER;
		}
		return Need4SteelWizardStep.SUMMARY;
	}

	readonly form = new FormNeed4SteelOffer();
	private readonly lastSavedOffer: Need4SteelOffer;

	constructor(offer: Need4SteelOffer, lastSavedOffer: Need4SteelOffer) {
		this.form = new FormNeed4SteelOffer();
		this.form.setMillOffer(offer);
		this.lastSavedOffer = lastSavedOffer;
	}

	reset() {
		this.form.setMillOffer(this.lastSavedOffer);
		this.form.updateValueAndValidity();
	}

	computeIndexStep() {
		return WizardStateMillOffer.COMPUTE_INDEX_STEP(this.form);
	}
}
export class Need4SteelWizardState {
	stepIndex: Need4SteelWizardStep = Need4SteelWizardStep.HEADER;
	isValid = false;
	exiting = false;
	errorInPage = false;
	readonly scrollPositionByStep = [0, 0, 0, 0, 0];
	readonly offer: WizardStateMillOffer;
	constructor(offer: Need4SteelOffer, lastSavedOffer: Need4SteelOffer) {
		this.offer = new WizardStateMillOffer(offer, lastSavedOffer);
	}
}
